var _defs, _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 324.9999,
    y1: 131.4851,
    x2: 324.9999,
    y2: 368.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2507,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9049
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#f5f3f5",
    stopOpacity: 0.2712
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 237.3275,
    y1: 252.8126,
    x2: 412.6561,
    y2: 252.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0263,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#f5f3f5",
    stopOpacity: 0.0486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0897,
    stopColor: "#f5f3f5",
    stopOpacity: 0.269
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1442,
    stopColor: "#f5f3f5",
    stopOpacity: 0.4643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#f5f3f5",
    stopOpacity: 0.6291
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2562,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#f5f3f5",
    stopOpacity: 0.8676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4364,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9857
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5074,
    stopColor: "#f5f3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6219,
    stopColor: "#f5f3f5",
    stopOpacity: 0.9291
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6835,
    stopColor: "#f5f3f5",
    stopOpacity: 0.841
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    stopColor: "#f5f3f5",
    stopOpacity: 0.7175
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    stopColor: "#f5f3f5",
    stopOpacity: 0.5584
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8755,
    stopColor: "#f5f3f5",
    stopOpacity: 0.3637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f5f3f5",
    stopOpacity: 0.138
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9756,
    stopColor: "#f5f3f5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 237.3275,
    y1: 194.2635,
    x2: 412.6561,
    y2: 194.2635,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.0311,368.515V315.7931H198.8133V131.4851H451.1864V315.6725H280.8739Zm-20.3476-61.5919h29.2177v40.1778L277.2,306.8025H442.3163V140.3551H207.6835Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 237.3275,
    y: 248.3775,
    width: 175.3286,
    height: 8.8701
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 237.3275,
    y: 189.8285,
    width: 175.3286,
    height: 8.8701
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.5f916ed09be0336a39376450e771a4d8.svg";
export { ForwardRef as ReactComponent };